import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    backgroundColor: "rgba(255,255,255,0.5)",
    display: "flex",
    flexDirection: "column",
    padding: "31px 37px 8px",
    minHeight: "100%",
    border: "1px solid #E5E5E5",
  },
}))

export default styles
